import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ChallengesDataService, ChallengesColumnsService } from '../../../services';
import { Challenge, ChallengesResult } from '../../../interfaces';
import { Editor } from 'primeng/editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-challenge-form',
  templateUrl: './challenge-form.component.html',
  styleUrls: ['./challenge-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ChallengeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public challenge: Challenge = {};
  public challengeForm: FormGroup = new FormGroup({});
  public challenges: Challenge[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  public Editor = ClassicEditor;
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private challengesDataService: ChallengesDataService,
    public challengesColumnsService: ChallengesColumnsService,
    public editorService: EditorService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ChallengeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Challenge - Edit');
        this.getChallenge(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.challenge !== 'undefined') {
      this.challenge = this.dynamicDialogConfig.data.challenge;
    }
    if (typeof this.challenge.id === 'undefined' || this.challenge.id === null) {
      this.challenge.id = null;
      this.challenge.isHeadline = false;
      this.challenge.autoPublishing = false;
      this.challenge.startPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.challenge.endPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.challenge.publishDate = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.challenge.isNew = false;
    }
    this.getChallenges();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'ChallengeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'ChallengeFormComponent');
  }

  getChallenge(id: number): void {
    this.isLoading = true;
    this.challengesDataService.getChallenge(id).subscribe((response: Challenge|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.challenge = response;
        this.prepareFrom();
      }
    });
  }

  getChallenges(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.challenges !== 'undefined' && this.dynamicDialogConfig.data.challenges.length > 0) {
      this.challenges = this.dynamicDialogConfig.data.challenges;
      return;
    }
    this.challengesDataService.getChallenges(this.parameters).subscribe((response: ChallengesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.challenges = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.challenge.startPublishing = moment(this.challenge.startPublishing).toDate();
    this.challenge.endPublishing = moment(this.challenge.endPublishing).toDate();
    this.challenge.publishDate = moment(this.challenge.publishDate).toDate();
    this.challengeForm = new FormGroup({
      id: new FormControl(this.challenge.id, []),
      title: new FormControl(this.challenge.title, []),
      titleAr: new FormControl(this.challenge.titleAr, []),
      titleFr: new FormControl(this.challenge.titleFr, []),
      picture: new FormControl(this.challenge.picture, []),
      content: new FormControl(this.challenge.content, []),
      contentAr: new FormControl(this.challenge.contentAr, []),
      contentFr: new FormControl(this.challenge.contentFr, []),
      isHeadline: new FormControl(this.challenge.isHeadline, [Validators.required, ]),
      autoPublishing: new FormControl(this.challenge.autoPublishing, [Validators.required, ]),
      startPublishing: new FormControl(this.challenge.startPublishing, []),
      endPublishing: new FormControl(this.challenge.endPublishing, []),
      publishDate: new FormControl(this.challenge.publishDate, [Validators.required, ]),
      status: new FormControl(this.challenge.status, [Validators.required, ]),
      isNew: new FormControl(this.challenge.isNew, [Validators.required, ]),
      ordering: new FormControl(this.challenge.ordering, []),
    });
  }

  list() {
    this.router.navigate(['/challenges']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.challengeForm.controls).forEach((field: any) => {
        const control = this.challengeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.challengeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.challenge = this.challengeForm.value;
    this.disableSubmit = true;
    console.log('challenge', this.challenge);
    if (typeof this.challenge.id !== 'undefined' && this.challenge.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.challengesDataService.updateChallenge(this.challenge).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('CHALLENGEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('CHALLENGENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.challengesDataService.addChallenge(this.challenge).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('CHALLENGECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('CHALLENGENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.challengeForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'challenges',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.challengeForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-challenge-form',
  templateUrl: './challenge-form.component.html',
  styleUrls: ['./challenge-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogChallengeFormComponent extends ChallengeFormComponent {
}

